import authorizationApi from '../interceptor/AuthorizationAxiosInterceptor';
import * as urlUtil from '../../util/UrlUtil'


/**
 * 本人確認に申し込み可能かどうか確認するAPIを呼ぶ.
 */
export function getAuditionAvailable() {
    const apiPath = urlUtil.identityVerifierUtil.auditionAvailableApiUrl(1)
    return authorizationApi.get(apiPath)
        .then(result => {
            return result
        })
        .catch(error => {
            throw error
        });
}

export function headAuditionSessionApi() {
    const path = location.search
    const jhsFreeSessionId = path.substr(path.indexOf('=') + 1)
    const apiPath = urlUtil.identityVerifierUtil.auditionSessionApiUrl(1, jhsFreeSessionId)
    return authorizationApi.head(apiPath)
}

/**
 * 本人確認の申し込みを完了するAPIを呼ぶ.
 * @param {string} name 名前
 * @param {string} mailAddress メールアドレス
 * @param {string} date_of_birth <date>生年月日
 * @param {string} image1 <binary> 画像(表)
 * @param {string} image2 <binary> 画像(裏)
 * @param {boolean} isApp <boolean> webViewかどうか
 */
export function postCompletedAuditionApi(name,　mailAddress, date_of_birth, image1, image2,isApp) {
    const apiPath = urlUtil.identityVerifierUtil.completedAuditionApiUrl(1)
    const formData = new FormData();
    formData.append("name", name);
    formData.append("mailaddress", mailAddress);
    formData.append("date_of_birth", date_of_birth);
    formData.append("document_type", "schoolIssued"); // 他のタイプがすべて廃止になったため固定値を埋めておきます。
    formData.append("image1", image1, "image1.jpg");
    // web申し込みの場合は「other」で送る PICTLINK-15799
    const inboundClientAgent = isApp? "app" : "other";
    formData.append("inboundClientAgent", inboundClientAgent);
    if(image2) {
        formData.append("image2", image2, "image2.jpg");
    }
    return authorizationApi.post(apiPath, formData)
        .then(result => {
            return result
        })
        .catch(error => {
            throw error
        });
}